module.exports = __webpack_public_path__ + "img/英文版_库尔_河南.a0ea2b46.webp";